import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M15.5348 3.51501L7.0498 12L15.5348 20.485L16.9498 19.071L9.8778 12L16.9498 4.92901L15.5348 3.51501Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronBigLeft"
);
